import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const allData = {
  Watch: [
    { name: "18-24", male: 60, female: 40, total: 20 },
    { name: "25-34", male: 45, female: 55, total: 35 },
    { name: "35-44", male: 50, female: 50, total: 15 },
    { name: "45-54", male: 40, female: 60, total: 25 },
    { name: "55+", male: 55, female: 45, total: 5 },
  ],
  Listen: [
    { name: "18-24", male: 30, female: 70, total: 10 },
    { name: "25-34", male: 50, female: 50, total: 20 },
    { name: "35-44", male: 40, female: 60, total: 25 },
    { name: "45-54", male: 60, female: 40, total: 30 },
    { name: "55+", male: 45, female: 55, total: 15 },
  ],
  Read: [
    { name: "18-24", male: 25, female: 75, total: 30 },
    { name: "25-34", male: 35, female: 65, total: 25 },
    { name: "35-44", male: 60, female: 40, total: 10 },
    { name: "45-54", male: 50, female: 50, total: 20 },
    { name: "55+", male: 40, female: 60, total: 15 },
  ],
  // Add more categories as needed
};

export default function EngagementRateGraphByGender() {
  const [selectedCategory, setSelectedCategory] = useState("Watch");

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const filteredData = allData[selectedCategory];

  return (
    <div>
      <FormControl
        variant="outlined"
        style={{ marginBottom: "4px", minWidth: 200 }}
      >
        <InputLabel>Content Type</InputLabel>
        <Select
          value={selectedCategory}
          onChange={handleCategoryChange}
          label="Content Type"
        >
          <MenuItem value="Watch">Watch</MenuItem>
          <MenuItem value="Listen">Listen</MenuItem>
          <MenuItem value="Read">Read</MenuItem>
          <MenuItem value="Devotion">Devotion</MenuItem>
          <MenuItem value="Play">Play</MenuItem>
        </Select>
      </FormControl>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          width={500}
          height={300}
          data={filteredData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(value) => `${value}%`} />
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend
            formatter={(value) =>
              value.charAt(0).toUpperCase() + value.slice(1)
            }
          />
          <Bar dataKey="female" fill="#8884d8" />
          <Bar dataKey="male" fill="#82ca9d" />
          <Bar dataKey="total" fill="#08b5ff" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
